<template>
  <div ref="blockRef" class="mx-auto px-4 max-w-6xl">
    <div class="flex flex-col justify-between gap-2 lg:flex-row">
      <h2
        v-if="block.title"
        v-html="formatTitle(block.title)"
        :class="`shrink-0 text-[clamp(1.5rem,-2.25rem+18.75vw,3.75rem)] leading-none ${block.title_color?.value} lg:pr-10`"
        data-gsap-target="title"
      />

      <div
        v-if="block.images?.length"
        class="grid grid-cols-4 items-center gap-6 max-w-xl lg:border-l-2 lg:border-purple-dark"
      >
        <div
          v-for="image in block.images"
          :key="image.id"
          class="flex items-center justify-center px-1 aspect-[4/3]"
          data-gsap-target="image"
        >
          <img
            :src="image.xs.url"
            :alt="image.xs.alt"
            class="h-16 w-auto object-contain"
            :width="image.xs.width"
            :height="image.xs.height"
            loading="lazy"
            draggable="false"
          >
        </div>
      </div>
    </div>

    <div
      v-if="block.text"
      v-html="block.text"
      class="prose mt-6 max-w-2xl md:mt-10"
      data-gsap-target="text"
    />
  </div>
</template>

<script setup lang="ts">
import type { Awards } from '~/statamic/types/block';

defineProps<{
  block: Awards;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const title = self.selector('[data-gsap-target="title"]');
    const text = self.selector('[data-gsap-target="text"]');
    const images = self.selector('[data-gsap-target="image"]');

    if (title) {
      useGsap.from(title, {
        x: -100,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }

    if (images?.length) {
      useGsap.from(images, {
        y: 10,
        stagger: 0.5,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }

    if (text) {
      useGsap.from(text, {
        y: 50,
        delay: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
